/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Component, ElementRef, input, viewChild, viewChildren } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { LoginViewState } from '../models/login-settings.model';

@Component({
  selector: 'abc-two-step-auth',
  templateUrl: './two-step-auth.component.html',
  styleUrl: './two-step-auth.component.scss',
  standalone: false,
})
export class TwoStepAuthComponent {
  public inputsList = viewChildren<ElementRef<HTMLInputElement>>('input');
  public submitButton = viewChild<ElementRef>('submitButton');

  public confirmationcodeFilled = input<boolean>(false);
  public confirmSecondFactor = input<() => void>();
  public cancelSecondFactor = input<() => void>();
  public setOptionalSecondFactor = input<() => void>();
  public onClick = input<(e: Event) => void>();
  public onPaste = input<(e: ClipboardEvent, index: number) => void>();
  public onInput = input<(e: Event, index: number) => void>();
  public onKeydown = input<(e: Event, index: number) => void>();
  public Form = input<UntypedFormGroup>();
  public viewState = input<LoginViewState>();
  public username = input<string>();
  public baseUrl = input<string>();
  public secret = input<string>();
  public issuer = input<string>();
  public placeholders = input<string[]>();
  public inputMode = input<string>();
  public inputType = input<string>();
  public res = input<ResourceSet>();
  public rtlEnabled: boolean;

  constructor(private resourceService: ResourceManagerService) {
    this.rtlEnabled = this.resourceService.isRightToLeftEnabled;
  }
}
